import React from "react";
import { Link } from "react-scroll";
import {
	House,
	UsersThree,
	Info,
	Calendar,
	BookBookmark,
	AddressBook,
	IntersectSquare,
} from "@phosphor-icons/react";
import { scrollToSection } from "../../helper/scrollFunction";
function Nav() {
	return (
		<>
			<ul className="font-normal flex gap-16 items-center list-none text-center mr-[-24px] max-[1069px]:hidden">
				<li className="group h-[80px]">
					<Link
						className="text-white flex items-center py-0 px-[1rem] h-[100%] cursor-pointer hover:border-b-4 hover:border-secondary hover:text-secondary"
						to="hero"
						spy={true}
						smooth={true}
						offset={0}
						duration={500}
					>
						<span className="mr-2">
							<House
								size={20}
								color="#FFFFFF"
								weight="regular"
								className="group-hover:fill-secondary"
							/>
						</span>
						Home
					</Link>
				</li>
				<li className="group h-[80px]">
					<Link
						className="text-white flex items-center py-0 px-[1rem] h-[100%] cursor-pointer hover:border-b-4 hover:border-secondary hover:text-secondary"
						to="about"
						spy={true}
						smooth={true}
						offset={-10}
						duration={500}
					>
						<span className="mr-2">
							<Info
								size={20}
								color="#FFFFFF"
								weight="regular"
								className="group-hover:fill-secondary"
							/>
						</span>
						About
					</Link>
				</li>
				<li className="group h-[80px]">
					<Link
						className="text-white flex items-center py-0 px-[1rem] h-[100%] cursor-pointer hover:border-b-4 hover:border-secondary hover:text-secondary"
						to="teams"
						spy={true}
						smooth={true}
						offset={-10}
						duration={500}
					>
						<span className="mr-2">
							<UsersThree
								size={20}
								color="#FFFFFF"
								weight="regular"
								className="group-hover:fill-secondary"
							/>
						</span>
						Team
					</Link>
				</li>
				<li className="group h-[80px]">
					<Link
						className="text-white flex items-center py-0 px-[1rem] h-[100%] cursor-pointer hover:border-b-4 hover:border-secondary hover:text-secondary"
						to="events"
						spy={true}
						smooth={true}
						offset={50}
						duration={500}
					>
						<span className="mr-2">
							<Calendar
								size={20}
								color="#FFFFFF"
								weight="regular"
								className="group-hover:fill-secondary"
							/>
						</span>
						Events
					</Link>
				</li>

				<li className="group h-[80px]">
					<Link
						className="text-white flex items-center py-0 px-[1rem] h-[100%] cursor-pointer hover:border-b-4 hover:border-secondary hover:text-secondary"
						to="join"
						spy={true}
						smooth={true}
						offset={50}
						duration={500}
					>
						<span className="mr-2 ml-0">
							<IntersectSquare
								size={20}
								color="#FFFFFF"
								weight="regular"
								className="group-hover:fill-secondary"
							/>
						</span>
						Join
					</Link>
				</li>
			</ul>
		</>
	);
}

export default Nav;
